<template>
    <el-dialog :visible="visible" class="ah-detail-dialog variable-statement-detail-editor-group-detail-dialog" @open="onOpen" @close="onClose">
        <template slot="title">
            <div class="title">
                <span>{{ this.isEditMode ? "編輯" : "新增" }}大群組</span>
            </div>
        </template>

        <div class="detail-row" style="padding-top: 30px">
            <div style="margin-bottom: 20px">
                <el-form ref="form" :rules="rules" :model="form" label-position="left" label-width="160px">
                    <div style="margin: 0 auto 20px auto">
                        <el-form-item prop="iteM_NAM" label="名稱">
                            <el-input v-model.trim="form.iteM_NAM" :maxlength="20" style="width: 220px" :show-word-limit="true" />
                        </el-form-item>
                        <el-form-item prop="grP_MEM" label="說明">
                            <el-input v-model.trim="form.grP_MEM" maxlength="50" show-word-limit />
                        </el-form-item>
                        <template v-if="isIncomeStatement">
                            <el-form-item prop="grP_NAM" label="綜合損益表">
                                <el-select v-model="form.grP_NAM" placeholder="請選擇" style="width: 195px">
                                    <el-option
                                        v-for="item in incomeStatementList"
                                        :label="`${item.id}. ${item.value}`"
                                        :value="item.id"
                                        :key="item.id"
                                        :disabled="!isIncomeOptionUsable(item.id)"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </template>
                        <template v-else>
                            <el-form-item prop="grP_NAM" label="財務分析表">
                                <el-select v-model="form.grP_NAM" placeholder="請選擇" style="width: 195px">
                                    <el-option v-for="item in financeStatementList" :label="`${item.id}. ${item.value}`" :value="item.id" :key="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                            <!-- <el-form-item prop="grP_AMT" label="財務分析初始金額">
                                <MoneyInput v-model="form.grP_AMT" allow-negative style="width: 195px" />
                            </el-form-item> -->
                            <!-- <el-form-item prop="isshare">
                                <template slot="label"> 同步顯示於財務支出 </template>
                                <el-checkbox v-model="form.isshare" :disabled="isSyncDisabled"> 啟用 </el-checkbox>
                                <ah-tip v-if="isSyncDisabled">只適用於財務支出</ah-tip>
                            </el-form-item> -->
                        </template>
                    </div>
                </el-form>
            </div>
            <div class="main-action">
                <el-button v-if="isEditMode" @click="onDelete"> 刪除 </el-button>
                <div v-else></div>
                <div>
                    <el-button @click="onClose">取消</el-button>
                    <el-button type="primary" class="primary-action" @click="onSubmit">
                        <span v-if="isEditMode">儲存</span>
                        <span v-else>新增</span>
                    </el-button>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import _ from 'lodash';
import { financeStatementList, accountingSettingGroup } from '@/assets/commonData/options';

export default {
    props: {
        visible: Boolean,
        fullList: {
            type: Array,
            default: () => [],
        },
        category: String,
        data: null,
        isIncomeOptionUsable: {
            type: Function,
            default: () => {},
        },
    },
    data() {
        return {
            incomeStatementList: [],
            financeStatementList,

            form: {
                iteM_NAM: '',
                grP_MEM: null,
                grP_NAM: undefined,
                grP_AMT: 0,
                isshare: false,
            },
            rules: {
                iteM_NAM: [{ required: true, message: '請輸入名稱' }],
            },
        };
    },
    computed: {
        isEditMode() {
            return !!this.data;
        },
        isIncomeStatement() {
            return this.category === 'invoiceSettings' || this.category === 'payoutSettings' || this.category === 'cInSettings' || this.category === 'cOutSettings';
        },
        isSyncDisabled() {
            return this.category !== 'cInElseSettings';
        },
        isNameDuplicated() {
            const found = _.chain(this.fullList)
                .filter((o) => o.iteM_NAM !== this.data?.iteM_NAM)
                .find(['iteM_NAM', this.form.iteM_NAM])
                .value();

            if (found) {
                this.$message({
                    showClose: true,
                    message: '大群組名稱不可重複',
                    type: 'error',
                });
                return true;
            }
            return false;
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.incomeStatementList = [...accountingSettingGroup.filter((o) => o.id > 3 && o.id < 9)];
        },
        onOpen() {
            this.$nextTick(() => {
                this.$refs.form.resetFields();

                if (this.isEditMode) {
                    this.form.iteM_NAM = this.data.iteM_NAM;
                    this.form.grP_MEM = this.data.grP_MEM;
                    this.form.grP_NAM = this.data.grP_NAM;
                    this.form.grP_AMT = this.data.grP_AMT;
                    this.form.isshare = this.data.isshare;
                } else {
                    this.form = {
                        iteM_NAM: '',
                        grP_MEM: null,
                        grP_NAM: null,
                        grP_AMT: 0,
                        isshare: false,
                    };
                }
            });
        },
        onClose() {
            this.$emit('close');
        },
        async onSubmit() {
            this.$refs.form.validate(async (valid) => {
                if (!valid) return false;
                this.onMutateGroup();
                return true;
            });
        },
        async onMutateGroup() {
            if (this.isNameDuplicated) return;

            if (this.isEditMode) this.$emit('update', this.form);
            else this.$emit('add', this.form);
            this.onClose();
        },

        async onDelete() {
            try {
                await this.$confirm('確定要刪除？', {
                    confirmButtonText: '確定',
                    cancelButtonText: '取消',
                });

                this.$emit('delete');
                this.onClose();
            } catch (e) {
                console.log(e);
            }
        },
    },
};
</script>

<style lang="scss">
.ah-detail-dialog.variable-statement-detail-editor-group-detail-dialog {
    .el-dialog {
        max-width: 560px;
    }
    .title {
        text-align: center;
    }
    .main-action {
        display: flex;
        justify-content: space-between;
    }
}
</style>
